import { render, staticRenderFns } from "./saml.vue?vue&type=template&id=23644932&"
import script from "./saml.vue?vue&type=script&lang=js&"
export * from "./saml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports